import React, { useEffect } from 'react';
import './RoomMonitorQueue.css';

const RoomMonitorQueue = ({ id, name, number, subscribeToRoom, queuesByRoom, socket }) => {
    const queue = queuesByRoom[id] || [];
    const colors = [' #87aff96e', '#3b6ff27d', '#3b6ff2'];
    useEffect(() => {
        subscribeToRoom(id);
    }, [subscribeToRoom, id]);

    return (
        <>


            <div className='RoomMonitorQueueContainer'>
                <div className='roomMonitorTitle'>
                    <span> חדר </span>
                    <span className='numberRoomTitle'>
                        {name !== "קבלה" ? number : "קבלה"}
                    </span>
                </div>

                <div className='roomMonitorQueueContent'>
                    {queue.length > 0 ? (
                        <>
                            <div className='curenntAndNextPatients'>
                                <div className='currentMonitorPatient'>
                                    <div className='currentPatientNumber'>
                                        {queue[0].patient.UniqueNumber && <div>{queue[0].patient.UniqueNumber}</div>}
                                    </div>
                                </div>
                                <div className='nextPatientsContainer'>
                                    {queue[1] && <div className='nextPatientTitle'>הבאים בתור</div>}

                                    <div className='next3MonitorPatients'>
                                        {queue[3] && <div className='next' style={{ backgroundColor: colors[0] }}>{queue[3].patient.UniqueNumber}</div>}
                                        {queue[2] && <div className='next' style={{ backgroundColor: colors[1] }}> {queue[2].patient.UniqueNumber}</div>}
                                        {queue[1] && <div className='next' style={{ backgroundColor: colors[2] }}>{queue[1].patient.UniqueNumber}</div>}

                                    </div>
                                </div>
                                <div className='numOfWaitPatientsContainer'>
                                    <div className='numOfWaitPatientsTitle'>מספר ממתינים</div>
                                    {/* decrease the current patient */}
                                    <div className='numOfWaitPatients'>{queue.length - 1}</div>
                                </div>
                            </div>

                        </>

                    ) : (
                        <p>אין ממתינים</p>
                    )}</div>
            </div>
        </>
    );
};

export default RoomMonitorQueue;
